import React from 'react';
import { Button } from 'react-bootstrap';
import './Ping.css';

function Ping() {
    return (
        <div>
            <Button id="btnCreate" variant="dark" className="btn-outline-dark">
                Create
            </Button>
            <Button id="btnDiscover" variant="dark" className="btn-outline-dark">
                Discover
            </Button>
        </div>
    );
}

export default Ping;
